import useLocalStorageState from "use-local-storage-state";

const localBaseUrl = 'https://local.cipher.kiev.ua:9090';

const b64EncodeUnicode = (str) => {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            (match, p1) => { return String.fromCharCode('0x' + p1); }
        )
    );
};

const loadKeys = () => {
    try {
        fetch(
            localBaseUrl + '/api/v1/token/connected',
            {headers: {'Content-Type': 'application/json'}}
        ).then((response) => {
            return response.json();
        }).then((data) => {
            localStorage.setItem('keyData', JSON.stringify(data));
        }).catch((error) => {
        });
    } catch (error) {
    }
};

const checkStatus = () => {
    try {
        fetch(
            localBaseUrl + '/api/v1/status',
            {headers: {'Content-Type': 'application/json'}}
        ).then((response) => {
            if (response.status === 200) {
                if (!localStorage.getItem('started')) {
                    localStorage.setItem('started', 'true');
                    loadKeys();
                    loadCa();
                }
            } else {
                if (localStorage.getItem('started')) {
                    localStorage.setItem('started', '');
                    localStorage.setItem('keyList', JSON.stringify([]));
                }
            }
        }).catch((error) => {
            if (localStorage.getItem('started')) {
                localStorage.setItem('started', '');
                localStorage.setItem('keyList', JSON.stringify([]));
            }
        });
    } catch (error) {
        if (localStorage.getItem('started')) {
            localStorage.setItem('started', '');
            localStorage.setItem('keyList', JSON.stringify([]));
        }
    }
};

const loadCa = () => {
    try {
        fetch(
            localBaseUrl + '/api/v1/certificateAuthority/supported',
            {headers: {'Content-Type': 'application/json'}}
        ).then((response) => {
            return response.json();
        }).then((data) => {
            localStorage.setItem('caList', JSON.stringify(data.ca));
        }).catch((error) => {
        });
    } catch (error) {
    }
};

const startSession = async () => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket',
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'}
            }
        );

        return await response.json();
    } catch (error) {}
};

const endSession = async (ticketUuid) => {
    if (!ticketUuid) {
        return;
    }

    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid,
            {
                method: 'DELETE',
                headers: {'Content-Type': 'application/json',}
            }
        );

        return await response.json();
    } catch (error) {}
};

const setSessionOptions = async (ticketUuid, options) => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid + '/option',
            {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(options)
            }
        );

        return await response.json();
    } catch (error) {}
};

const setData = async (ticketUuid, str) => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid + '/data',
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({base64Data: b64EncodeUnicode(str)})
            }
        );

        return await response.json();
    } catch (error) {}
};

const setSessionKeyStore = async (ticketUuid, data) => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid + '/keyStore',
            {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            }
        );

        return await response.json();
    } catch (error) {}
};

const verify = async (ticketUuid, data) => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid + '/keyStore/verifier',
            {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            }
        );

        return await response.json();
    } catch (error) {}
};

const create = async (ticketUuid, data) => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid + '/ds/creator',
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            }
        );

        return await response.json();
    } catch (error) {}
};

const check = async (ticketUuid) => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid + '/ds/creator',
            {
                method: 'GET',
                headers: {'Content-Type': 'application/json'}
            }
        );

        return !response.ok;
    } catch (error) {}
}

const getSigned = async (ticketUuid) => {
    try {
        const response = await fetch(
            localBaseUrl + '/api/v1/ticket/' + ticketUuid + '/ds/base64Data',
            {
                method: 'GET',
                headers: {'Content-Type': 'application/json'}
            }
        );

        return await response.json();
    } catch (error) {}
};

const verifyKey = (form, callback) => {
    startSession().then((data) => {
        let sessionId = data.ticketUuid;

        setSessionOptions(sessionId, {caId: form.ca}).then((data) => {
            setSessionKeyStore(sessionId, {keyStorePath: form.signPath}).then((data) => {
                verify(sessionId, {keyStorePassword: form.password2}).then((data) => {
                    endSession(sessionId).then((data) => {});

                    callback(data);
                });
            });
        });
    });
}

const signString = (string, form, callback) => {
    startSession().then((data) => {
        let sessionId = data.ticketUuid;

        setSessionOptions(sessionId, {
            signatureType: 'attached',
            embedSignatureTs: 'true',
            embedDataTs: 'true',
            embedCertificateType: 'signerCertAndCaInfo',
            cadesType: 'CAdESXLong',
            caId: form.ca
        }).then((data) => {
            setSessionKeyStore(sessionId, {
                keyStorePath: form.signPath
            }).then((data) => {
                setData(sessionId, string).then((data) => {
                    create(sessionId, {keyStorePassword: form.password2}).then((data) => {
                        setTimeout(() => {
                            check(sessionId).then(data => {
                                getSigned(sessionId).then((data) => {
                                    endSession(sessionId).then((data) => {});

                                    callback(data);
                                });
                            });
                        }, 2000);
                    });
                });
            });
        });
    });
};

export default {
    loadKeys,
    checkStatus,
    loadCa,
    startSession,
    endSession,
    setSessionOptions,
    setData,
    setSessionKeyStore,
    verify,
    create,
    check,
    getSigned,
    verifyKey,
    signString
};